import * as types from "../action-types";

const myNavActive = localStorage.getItem('navActive');
const initState = {
  sidebarCollapsed: false,
  settingPanelVisible: false,
  navActive: myNavActive? myNavActive :'1'
};
export default function app(state = initState, action) {
  switch (action.type) {
    case types.APP_TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarCollapsed: !state.sidebarCollapsed,
      };
    case types.APP_TOGGLE_SETTINGPANEL:
      return {
        ...state,
        settingPanelVisible: !state.settingPanelVisible,
      };
      case types.APP_NAV_UPTADE:
      return {
        ...state,
        navActive: action.active,
      };
    default:
      return state;
  }
}
